import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchPointBalanceFailure } from '../../../Redux/point/pointActions';
import ModalWrapper from './ModalWrapper';
import { withTranslation } from 'react-i18next';

class LoginModal extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            show:true
         }
    }
    // Disabling Points Balance API
    // componentDidMount(){
    //     if(this.props.show && this.props.pointBalance){
    //         this.props.fetchPointBalanceFailure()
    //     }
    // }
    setModalView=()=>{
        this.setState({
            show:false
        })
    }
    render() { 
        const {t}= this.props
        return ( 
            <ModalWrapper show={ this.props.show}>
                <div 
                    className="p-4 bg-light mx-auto text-center py-md-5 py-4" 
                    style={{width:'40rem'}}> 
                    <span>{t("To use FlexxPay rewards, please login to FlexxPay through your portal or mobile app -")} <a href="https://play.google.com/store/apps/details?id=com.flexxpay.android&hl=en≷=US" className="loginModal">{t("Play store ( Android users)")} </a>{t("Or")}<a href="https://apps.apple.com/us/app/flexxpay/id1491143292" className="loginModal"> {t("App store ( iOS users)")} </a></span>
                    <br/>
                    <button 
                        className="btn btn-secondary mt-3 mx-2"
                        onClick={()=>{this.props.close(false)}}>
                        <span className="fw-bold ">{t("Close")}</span>
                    </button>
                </div>
            </ModalWrapper>
         );
    }
}
const mapStateToProps = state => {
    return {
        pointBalance:state.point.pointBalance,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchPointBalanceFailure : () => dispatch(fetchPointBalanceFailure()),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(LoginModal))   ;
